document.addEventListener('DOMContentLoaded', () => {
  const swatches = document.querySelectorAll('.swatch');
  if (!swatches.length) return;

  const mediaItems = document.querySelectorAll('.heroMedia__MediaItem');
  const titles = document.querySelectorAll('.heroMedia__Title');
  const slickCarousels = document.querySelectorAll('.watchSlider__Carousel--SwatchControlled');

  const ACTIVE_SWATCH_CLASS = 'swatch--Active';
  const ACTIVE_MEDIA_CLASS = 'heroMedia__MediaItem--Active';
  const ACTIVE_TITLE_CLASS = 'heroMedia__Title--Active';

  const disableSwatches = () => {
    swatches.forEach(swatch => {
      swatch.setAttribute('disabled', 'disabled');
      swatch.classList.add('swatch--Disabled');
    });
  };

  const enableSwatches = () => {
    swatches.forEach(swatch => {
      swatch.removeAttribute('disabled');
      swatch.classList.remove('swatch--Disabled');
    });
  };

  const clearActiveStates = () => {
    swatches.forEach(swatch => swatch.classList.remove(ACTIVE_SWATCH_CLASS));
    mediaItems.forEach(item => item.classList.remove(ACTIVE_MEDIA_CLASS));
    titles.forEach(title => title.classList.remove(ACTIVE_TITLE_CLASS));
  };

  const activateByHandle = (handle) => {
    if (!handle) return;

    const targetSwatch = document.querySelector(`.swatch[data-handle="${handle}"]`);
    const targetMedia = document.querySelector(`.heroMedia__MediaItem[data-product="${handle}"]`);
    const targetTitle = document.querySelector(`.heroMedia__Title[data-product="${handle}"]`);

    clearActiveStates();

    if (targetSwatch) {
      targetSwatch.classList.add(ACTIVE_SWATCH_CLASS);
    }

    if (targetMedia) {
      targetMedia.classList.add(ACTIVE_MEDIA_CLASS);

      const video = targetMedia.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {});
      }
    }

    if (targetTitle) {
      targetTitle.classList.add(ACTIVE_TITLE_CLASS);
    }
  };

  const goToSlickIndex = (index) => {
    if (typeof window.jQuery === 'undefined') {
      enableSwatches();
      return;
    }

    let triggered = false;

    slickCarousels.forEach(carousel => {
      const $carousel = window.jQuery(carousel);
      if (!$carousel.hasClass('slick-initialized')) return;

      triggered = true;
      $carousel.slick('slickGoTo', index);
    });

    if (!triggered) {
      enableSwatches();
    }
  };

  /* ----------------------------
     Swatch → Slider
  ----------------------------- */
  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      if (swatch.hasAttribute('disabled')) return;

      const handle = swatch.getAttribute('data-handle');
      const index = parseInt(swatch.getAttribute('data-index'), 10);

      if (!handle || Number.isNaN(index)) return;

      disableSwatches();
      activateByHandle(handle);
      goToSlickIndex(index);
    });
  });

  /* ----------------------------
     Slider → Swatch (SOURCE OF TRUTH)
  ----------------------------- */
  if (typeof window.jQuery !== 'undefined') {
    window.jQuery(slickCarousels).on(
      'afterChange',
      (event, slick, currentSlide) => {
        enableSwatches();

        // data-index is already zero-based (per your Liquid fix)
        const matchingSwatch = document.querySelector(
          `.swatch[data-index="${currentSlide}"]`
        );

        if (!matchingSwatch) return;

        const handle = matchingSwatch.getAttribute('data-handle');
        activateByHandle(handle);
      }
    );
  }
});